/**
 * Sync / settings API (providers, sync mode, orphans, merge)
 */

import type {
  SyncMode,
  OrphanedTasksReport,
  MergeDecision,
  ProviderInfo,
  ProviderId,
} from '../types';
import { fetchApi } from './fetch';

export type { SyncMode, OrphanedTasksReport, MergeDecision, ProviderInfo, ProviderId };

export async function getProviders(): Promise<ProviderInfo[]> {
  return fetchApi<ProviderInfo[]>('/settings/providers');
}

export async function getSyncMode(): Promise<SyncMode> {
  return fetchApi<SyncMode>('/settings/sync-mode');
}

export async function setSyncMode(
  mode: ProviderId,
  apiKey?: string
): Promise<{ success: boolean; mode: string; providerName: string }> {
  return fetchApi<{ success: boolean; mode: string; providerName: string }>(
    '/settings/sync-mode',
    { method: 'POST', body: JSON.stringify({ mode, apiKey }) }
  );
}

export async function detectOrphans(): Promise<OrphanedTasksReport> {
  try {
    return await fetchApi<OrphanedTasksReport>('/sync/orphans');
  } catch (error: any) {
    if (error.message?.includes('404') || error.status === 404) {
      return {
        localOnly: [],
        todoistOnly: [],
        requiresUserDecision: false,
      };
    }
    throw error;
  }
}

export async function applyMergeDecisions(
  decisions: MergeDecision[]
): Promise<{ success: boolean; applied: number }> {
  try {
    return await fetchApi<{ success: boolean; applied: number }>(
      '/sync/apply-merge-decisions',
      { method: 'POST', body: JSON.stringify({ decisions }) }
    );
  } catch (error: any) {
    if (error.message?.includes('404') || error.status === 404) {
      return { success: true, applied: 0 };
    }
    throw error;
  }
}
